import React, { useEffect, useState } from "react";
import "./style.scss";
import Table from "../../Table";
import goldMedal from "../../../assets/icons/Gold_medal.svg";
import silverMedal from "../../../assets/icons/Silver_medal.svg";
import bronzeMedal from "../../../assets/icons/Bronze_medal.svg";
import rankMedal from "../../../assets/icons/rank_logo.svg";
import TradingGrowth from "../../AccountMetrics/TradingGrowth";
import Statistics from "../../AccountMetrics/Statistics";
import CloseTrades from "../../AccountMetrics/CloseTrades";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { leaderboard } from "../../../utils/store/reducers/competitionSlice";
import { getLeaderboard } from "../../../utils/apis/competition";
import { useLocation, useParams } from "react-router-dom";
import moment from "moment";
import { formatDateInTimeZone } from "../../../utils/helpers/string";
const CompetitonDetail = () => {
  const { idToken } = useSelector((state) => state.auth);
  const [leaderboard, setLeadeboard] = useState([]);
  const { id } = useParams();
  const dispatch = useDispatch();
  const { state } = useLocation();

  const getLeaderboards = async () => {
    const res = await getLeaderboard(idToken, Number(id));
    setLeadeboard(res);
  };

  useEffect(() => {
    getLeaderboards();
  }, []);

  const columns = [
    {
      Header: "#",
      accessor: "position",
      Cell: ({ row, value }) => {
        return (
          <>
            <div className="rank_Wrapper">
              <img
                src={`${
                  row.index + 1 === 1
                    ? goldMedal
                    : row.index + 1 === 2
                    ? silverMedal
                    : row.index + 1 === 3
                    ? bronzeMedal
                    : rankMedal
                }`}
                alt="trophy icon"
              />{" "}
            </div>
          </>
        );
      },
    },
    { Header: "Name", accessor: "name" },
    {
      Header: "Date",
      accessor: "date",
    },
    { Header: "Account Size", accessor: "account_size" },
    {
      Header: "Balance",
      accessor: "balance",
    },
    { Header: "login Id", accessor: "login" },
  ];
  const [timeRemaining, setTimeRemaining] = useState(
    moment
      .utc(state?.close_entry_on, "DD-MM-YYYY")
      .diff(moment.utc(), "milliseconds")
  );

  useEffect(() => {
    const calculateTimeRemaining = () =>
      moment
        .utc(state?.close_entry_on, "DD-MM-YYYY")
        .diff(moment.utc(), "milliseconds");

    const timerInterval = setInterval(() => {
      const remaining = calculateTimeRemaining();
      setTimeRemaining(remaining > 0 ? remaining : 0);
    }, 1000);

    return () => clearInterval(timerInterval);
  }, [state?.close_entry_on]);

  const duration = moment.duration(timeRemaining);
  const days = String(duration.days()).padStart(2, "0");
  const hours = String(duration.hours()).padStart(2, "0");
  const minutes = String(duration.minutes()).padStart(2, "0");
  const seconds = String(duration.seconds()).padStart(2, "0");
  return (
    <>
      <div className="competitonDetail_container">
        <div className="competitionDetail_wrapper">
          <div className="topSection">
            <div className="competitionDetail_status">
              <h2>{state.name}</h2>
              <p>{state.name}</p>
              <div
                className={`comp_status ${
                  state.status === "Participated" || state.status === "End"
                    ? "red_status"
                    : state.status === "Upcoming"
                    ? "yellow_status"
                    : "green_status"
                }`}
              >
                <p>{state.status}</p>
              </div>
            </div>
            <div className="competitionDetail_info">
              <div className="compDetail_info_box">
                <p className="compDetail_header">End Date</p>
                <p className="info">{formatDateInTimeZone(state?.end_Date)}</p>
              </div>
              <div className="compDetail_info_box">
                <p className="compDetail_header">Ends In</p>
                <p className="info">{`${days}d : ${hours}h : ${minutes}m : ${seconds}s left`}</p>
              </div>
              <div className="compDetail_info_box">
                <p className="compDetail_header">Prize Found</p>
                <p className="info">First prize {state?.first_prize}</p>
              </div>
              <div className="compDetail_info_box">
                <p className="compDetail_header">Contestant</p>
                <p className="info">
                  {state?.participated_contestants +
                    "/" +
                    state?.total_contestants}
                </p>
              </div>
            </div>
          </div>
          <div className="leaderboardTable">
            <div className="leaderboardTable_container">
              <div className="leaderboardTable_wrapper">
                <Table columns={columns} data={leaderboard || []} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="trading_growth_container">
        <TradingGrowth />
      </div>
      <div className="statistic_wrapper">
        <Statistics />
      </div>
      <div className="closedTrader_wrapper">
        <CloseTrades />
      </div>
    </>
  );
};

export default CompetitonDetail;
